





















































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  condition: any,
  students: any[],
  password_ids: any[],
  delete_ids: any[],
  reset_login_failed_count_ids: any[],
  isAllCheckedPassword: boolean,
  isAllCheckedDelete: boolean,
  isAllCheckedResetLoginFailedCount: boolean,
  nendo: number
  nendos: number[]
  errors: any[],
  isShowPagination: boolean
  fields: any[]
  totalCount: number
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      condition: {
        grade: "",
        room_name: "",
        student_no: "",
        student_no_character: "",
        name: "",
        row_count: 50,
        page: 1,
      },
      students: [],
      password_ids: [],
      delete_ids: [],
      reset_login_failed_count_ids: [],
      isAllCheckedPassword: false,
      isAllCheckedDelete: false,
      isAllCheckedResetLoginFailedCount: false,
      nendo: null,
      nendos: [],
      errors: [],
      isShowPagination: false,
      fields: [],
      totalCount: null,
    });

    // ログイン失敗数リセット
    const resetLoginFailedCount = async () => {
      if (state.reset_login_failed_count_ids.length == 0) {
        alert('対象の生徒をチェックしてください。');
        return;
      }
      if (!confirm('ログイン失敗回数のリセットを行います。よろしいですか？')) {
        return;
      }
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_list/reset_login_failed_count`, {ids: state.reset_login_failed_count_ids}).then(response => {
        alert("リセットが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      window.location.reload();
    }

    // パスワード再設定メール送信メソッド
    const sendResetMail = async () => {
      if (state.password_ids.length == 0) {
        alert('パスワード設定する生徒をチェックしてください。');
        return;
      }
      if (!confirm('パスワード設定を行います。よろしいですか？')) {
        return;
      }
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_list/send_reset_mail`, {ids: state.password_ids}).then(response => {
        alert("パスワード設定が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      window.location.reload();
    }

    // 生徒削除
    const studentDelete = async () => {
      if (state.delete_ids.length == 0) {
        alert('削除する生徒をチェックしてください。');
        return;
      }
      if (!confirm('本当に削除してもよろしいですか？')) {
        return;
      }
      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_list/students_delete`, {ids: state.delete_ids}).then(response => {
        alert("削除処理が完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
      window.location.reload();
    }

    

    const clearCondition = () => {
      state.condition = {
        grade: "",
        room_name: "",
        student_no: "",
        student_no_character: "",
        name: "",
        row_count: 50,
        page: 1,
      };
    }

    const to = (page: string) => {
      context.root.$router.push(page).catch(err => {});
    }


    const toStudentSheetList = (student: any) => {
      context.root.$store.commit("setStudentNoCharacter", student.student_no_character);
      context.root.$store.commit("setStudentName", student.name);
      context.root.$router.push(`/teacher_site/student_sheet_list`).catch(err => {});
    }

    watch(() => state.isAllCheckedPassword, (newVal, oldVal) => {

      state.password_ids = [];

      if (newVal) {

        state.password_ids = state.students.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedDelete, (newVal, oldVal) => {

      state.delete_ids = [];

      if (newVal) {

        state.delete_ids = state.students.map(x => x.id);
      }
    });

    watch(() => state.isAllCheckedResetLoginFailedCount, (newVal, oldVal) => {

      state.reset_login_failed_count_ids = [];

      if (newVal) {

        state.reset_login_failed_count_ids = state.students.map(x => x.id);
      }
    });

    // 年度切替ボタン押下
    const updateNendo = async () => {

      if(!window.confirm("年度を切り替えます。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/teacher/student_list/update_nendo/${state.nendo}`).then(response => {
        alert("処理が完了しました。");
        window.location.reload();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.errors = [];
      await http.get(`/api/teacher/student_list?${Common.BuildQuery(state.condition, 'search_student')}`).then(response => {
        state.students = response.data.students;
        state.totalCount = state.students.length > 0 ? state.students[0].full_count : 0;

        state.nendo = response.data.nendo;
        // 年度プルダウンを基準年度からプラマイ5年で作成
        var startNendo = state.nendo - 5;
        var endNendo = state.nendo + 5;
        for(let nendo = startNendo; nendo <= endNendo; nendo++){
          state.nendos.push(nendo);
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          alert(`${error.response.data.errors[0]}`);
          context.root.$router.push("/teacher_site/nendo_edit").catch(err => {});
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }


    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      state.fields.push({key: "grade", label: "学年", sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "room_name_sort_key", label: "クラス名", sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "student_no", label: "出席番号", sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "student_no_character", label: "学籍番号", sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "name", label: "生徒名", sortable: true, class: 'text-center b-table-th-td'});
      state.fields.push({key: "email", label: "Mail", sortable: true, class: 'text-center b-table-th-td'});

      if(context.root.$store.getters.isOptionClassroomActive){
        state.fields.push({key: "classroom_student_id", label: "Classroom生徒ID", sortable: true, class: 'text-center b-table-th-td'});
      } else if(context.root.$store.getters.isOptionTeamsActive){
        state.fields.push({key: "teams_principal_name", label: "Teamsプリンシパル", sortable: true, class: 'text-center b-table-th-td'});
      }

      if(context.root.$store.getters.isOptionStudentManageActive && context.root.$store.getters.isAdminOrTeacher1){
        state.fields.push({key: "login_failed_count", label: "ロック状態", sortable: true, class: 'text-center b-table-th-td', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "150px"}});
      }

      state.fields.push({key: "student_page", label: "生徒ページへ", class: 'text-center', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "140px"}});

      if(context.root.$store.getters.isAdminOrTeacher1){
        state.fields.push({key: "delete", label: "生徒削除", class: 'text-center', thStyle: {"vertical-align": "middle", "white-space": "nowrap", width: "150px"}});
      }

      await search();
      state.isShowPagination = true;
    })

    return {
      ...toRefs(state),
      sendResetMail,
      studentDelete,
      clearCondition,
      to,
      toStudentSheetList,
      updateNendo,
      search,
      changePage,
      resetLoginFailedCount,
    }
  }
})
